module.exports = __webpack_public_path__ + "img/tee-name.3485aa58.svg";